import { Map, List, Seq } from "immutable";

export function createListReducer(actions, Record = null) {

    const INITIAL_STATE = Map({
        data: Map({}),
        pages: Map({
            1: List([])
        }),
        pagingation: Map({
            page: 1,
            pageSize: 20,
            totalPages: null
        }),
        params: Map({}),
        filters: Map({}),
        error: null,
        loading: false
    });

    return (state = INITIAL_STATE, { type, payload, error }) => {
        switch (type) {
        case actions.FETCH:
            return state.withMutations(mutator => {
                return mutator
                    .setIn(["pagination", "page"], payload.pagination.page)
                    .setIn(["pagination", "pageSize"], payload.pagination.pageSize)
                    .mergeIn(["params"], payload.params)
                    .mergeIn(["filters"], payload.filters)
                    .set("loading", true);
            });
        case actions.FETCHED:
            return state.withMutations(mutator => {
                return mutator
                    .mergeIn(["data"], Seq(List(payload.data.list)).map(_ => Record ? new Record(_) : _).toMap())
                    .setIn(["pages", payload.pagination.page], List(payload.data.list.map(_ => _.id)))
                    .setIn(["pagination", "totalPages"], payload.data.size)
                    .set("loading", false);
            });
        case actions.FETCH_FAILED:
            return state.withMutations(mutator => {
                return mutator
                    .set("error", error)
                    .set("loading", false);
            });
        default:
            return INITIAL_STATE;
        }
    };

}